import { render, staticRenderFns } from "./topicHot.vue?vue&type=template&id=1d117877&scoped=true"
import script from "./topicHot.vue?vue&type=script&lang=js"
export * from "./topicHot.vue?vue&type=script&lang=js"
import style0 from "./topicHot.vue?vue&type=style&index=0&id=1d117877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d117877",
  null
  
)

export default component.exports